/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode, BaseSyntheticEvent } from 'react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { GridRowCustomVisibilityRuletModal } from '../row-actions/custom-row-visible-rule-modal';
import { CQAppStore } from '../../../../../store/cq-app-store';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { AppliedRuleGridComponent } from '../../grid-applied-rule.component';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { ActionMapperController } from '../action-controller/action-mapper';
import GridRightPaneComponentName from './grid-right-pane-component-name';

export class CustomRowActionComponent
    extends Component<{ selectedTemplateName: string, action: any }, any> {

    private gridController: GridTemplateConfigurationController;
    private gridActionsReducer: GridActionsReducer;
    private componentList: any;
    private vfPageComponentList: any;
    constructor(props: Readonly<{ selectedTemplateName: string, action: any }>) {
        super(props);
        this.gridController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.state = {
            isApplyRuleModalVisisble: false,
            label: '',
            isFormValid: false,
            actionType: '',
            componentNameSpace: 'c-',
            componentName: '',
            popupType: false,
            isActionSaved: false,
            rowActionType: 'custom_row_action',
            isRuleApplied: false,
            visibilityRuleObj: {},
            name: '',
            visibilityRuleFields: [],
            isVisible: '',
            parentFields: [],
            actionTypesArray: ['VF_PAGE', 'LIGHTNING_COMPONENT'],
            additionalFieldsArray: [],
            isComponentNameSpaceEditable: false
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps && nextProps.action.name !== this.props.action.name) {
            this.setState({
                isApplyRuleModalVisisble: false,
                label: '',
                isFormValid: false,
                actionType: '',
                componentNameSpace: '',
                popupType: false,
                isActionSaved: false,
                isRuleApplied: false,
                visibilityRuleObj: {},
                name: '',
                visibilityRuleFields: [],
                isVisible: '',
                parentFields: [],
                additionalFieldsArray: [],
            });
        }
    }

    public render(): ReactNode {
        const { ruleObject }: any = this.extractStoreData();
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height slds-p-around_small">
                        <div className="slds-grid slds-grid_vertical full-height scroll-content">
                            <h2 className="slds-text-heading_small slds-m-bottom_medium">Row Actions</h2>
                            <dl className="slds-dl_horizontal slds-m-bottom_medium">
                                <dt className="slds-dl_horizontal__label">Custom Action</dt>
                            </dl>
                            <div className="slds-grid slds-grid_vertical full-height scroll-content">
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Name</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Name" value={this.state.name}
                                            onChange={this.onNameChange} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Label</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Label" value={this.state.label}
                                            onChange={this.onLabelChange} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Action Type</label>
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select
                                                value={this.state.actionType} className="slds-select" id="select-02" onChange={this.setActionType}>
                                                <option value="">Please select</option>
                                                {this.state.actionTypesArray.map((actionType: any, index: number) => {
                                                    return (<option key={actionType + index}
                                                        value={actionType}>{actionType}</option>);
                                                })};
                                        </select>
                                        </div>
                                    </div>
                                </div>
                                <GridRightPaneComponentName
                                    isDisabled= {!this.state.actionType}
                                    onSelect= {this.onComponentNameChange}
                                    actionType= {this.state.actionType}
                                    key= "customRowAction"
                                    value= {this.state.componentName}
                                />
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Component NameSpace</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" disabled={!this.state.isComponentNameSpaceEditable} placeholder="Add Component NameSpace" value={this.state.componentNameSpace}
                                            onChange={this.setComponentNameSpace} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element slds-grid slds-grid_vertical-align-center">
                                    <div className="slds-form-element__control">
                                        <input type="checkbox"
                                            aria-describedby="checkbox-toggle-32"
                                            disabled={this.state.actionType === 'VF_PAGE'}
                                            checked={this.state.popupType}
                                            onChange={this.setPopupType} />
                                    </div>
                                    <label className="slds-form-element__label">Popup Type</label>
                                </div>
                            </div>
                            {
                                this.state.isRuleApplied ? <AppliedRuleGridComponent ruleObject={ruleObject} toggleModalVisibility={this.toggleRuleModalVisibility} deleteRule={this.deleteRule} /> : <button disabled={!this.state.name} className="slds-button slds-button_brand full-width slds-m-bottom_small"
                                    onClick={() => { this.toggleRuleModalVisibility(); }}>Add Rule</button>
                            }
                            <button disabled={!this.state.name || !this.state.isFormValid} className="slds-button slds-button_brand slds-m-bottom_small full-width"
                                onClick={this.updateCustomAction}>Save Custom Action</button>
                        </div>
                    </div>
                </div>
                {
                    this.state.isApplyRuleModalVisisble && <GridRowCustomVisibilityRuletModal
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleRuleModalVisibility}
                        ruleObject={ruleObject}
                        actionType={this.state.name}
                        updateVisibilityRuleObj={this.updateVisibilityRuleObj}
                    />
                }
            </>
        );
    }

    /**
     * @private
     * @memberof CustomRowActionComponent
     */
    private extractStoreData = () => {
        let ruleObject = {};
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj: any = ruleElements && ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const rowActions = gridObj && gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};
        if (rowActions && rowActions.hasOwnProperty(this.state.name)) {
            ruleObject = rowActions[this.state.name];
        }
        return { ruleObject, gridObj };
    }

    public deleteRule = () => {
        const selectedRowAction = CQMasterDataStore.GridObject.selectedRowAction;
        this.gridActionsReducer.deleteViewModel(selectedRowAction.name, this.props.selectedTemplateName, 'rowActions');
        this.updateVisibilityRuleObj(false, {}, [], 'false', [], []);
        let rowFormRules = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'rowFormRules');
        if (rowFormRules.hasOwnProperty(this.state.name)) {
            delete rowFormRules[this.state.name]
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'rowFormRules', rowFormRules)
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private toggleRuleModalVisibility = () => {
        this.setState({
            isApplyRuleModalVisisble: !this.state.isApplyRuleModalVisisble
        })
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onComponentNameChange = (addedVal: string, nameSpacePrefix: string) => {
        this.setState({
            componentName: addedVal,
            componentNameSpace: this.state.actionType === 'VF_PAGE'? 
                                    nameSpacePrefix ? nameSpacePrefix+'__' : 'compliancequest__' 
                                    :
                                    nameSpacePrefix ? nameSpacePrefix : this.state.componentNameSpace,
            isComponentNameSpaceEditable: false
        }, () => {
            this.isFormValid();
        });

    }

    public updateVisibilityRuleObj = (isRuleApplied: boolean, visibilityRuleObj: any, fields: any, isVisible: string, parentFields: [], additionalFieldsArray: any) => {
        this.setState({
            isRuleApplied: isRuleApplied,
            visibilityRuleObj: visibilityRuleObj,
            visibilityRuleFields: fields,
            isVisible,
            parentFields,
            additionalFieldsArray
        }, () => {
            this.isFormValid();
            // this.updateCustomAction();
        });
    }

    private setActionType = (e: BaseSyntheticEvent) => {
        const actionType = e.target.value;
        const popupType = actionType === 'VF_PAGE' ? false : true;
        this.setState({
            actionType,
            popupType,
            componentNameSpace: popupType ? 'c__' : this.state.componentNameSpace,
            componentName: '',
            searchText: '',
            searchResult: []
        }, () => {
            this.isFormValid();
        })
    }

    private setPopupType = (e: BaseSyntheticEvent) => {
        this.setState({
            popupType: !this.state.popupType
        }, () => {
            if (!this.state.componentNameSpace && this.state.popupType) {
                this.setState({
                    componentNameSpace: 'c__',
                    isComponentNameSpaceEditable: false
                })
            }
            this.isFormValid();
        })
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onLabelChange = (e: BaseSyntheticEvent) => {
        const enteredVal = e.target.value;
        this.setState({
            label: enteredVal
        }, () => {
            this.isFormValid();
        });
    }

    private onNameChange = (e: BaseSyntheticEvent) => {
        const enteredVal = e.target.value;
        this.setState({
            name: enteredVal
        }, () => {
            this.isFormValid();
        });
    }


    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private setComponentNameSpace = (e: BaseSyntheticEvent) => {
        const enteredVal = e.target.value;
        this.setState({
            componentNameSpace: enteredVal
        }, () => {
            this.isFormValid();
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private isFormValid = () => {
        if (!this.state.componentName || !this.state.componentNameSpace || !this.state.componentName || !this.state.actionType) {
            this.setState({
                isFormValid: false
            })
        } else {
            this.setState({
                isFormValid: true
            })
        }
        if (this.state.isRuleApplied) {
            this.setState({
                isFormValid: true
            })
        }
    }

    private resetCustomAction = () => {
        this.setState({
            isApplyRuleModalVisisble: false,
            label: '',
            isFormValid: false,
            actionType: '',
            componentNameSpace: 'c-',
            isComponentNameSpaceEditable: false,
            popupType: false,
            isActionSaved: false,
            isRuleApplied: false,
            visibilityRuleObj: {},
            name: '',
            visibilityRuleFields: [],
            isVisible: '',
            parentFields: [],
        });
    }

    private updateCustomAction = () => {
        CQAppStore.loader.setVisibility(true);
        if (this.state.isFormValid) {
            this.setState({
                isActionSaved: true
            }, () => {
                this.updateRuleElements()
                const actionObject: any = ActionMapperController[this.state.rowActionType].getControllerInstance(this.state);
                this.saveDataToStore(actionObject);
                let rowAction = [...CQMasterDataStore.GridObject.rowActionTypes];
                if (actionObject.actionJSON.hasOwnProperty('rowActions')) {
                    rowAction.push(actionObject.actionJSON.rowActions);
                } else {
                    rowAction.push(this.state);
                }
                CQMasterDataStore.GridObject.updateGridField('rowActionTypes', rowAction);
                this.saveToOrderingList(actionObject);
                this.resetCustomAction();
                setTimeout(() => { CQAppStore.loader.setVisibility(false); }, 2000);
            });
        }
    }

    private saveToOrderingList = (actionObject: any) => {
        let orderedRowAction = [...CQMasterDataStore.GridObject.orderedRowAction];
        if (!actionObject.actionJSON.hasOwnProperty('rowFormRules')) {
            const ifExist = this.checkIfRecordExist();
            if (ifExist) {
                orderedRowAction.forEach((orderedAction: any, index: number) => {
                    let action = { ...orderedAction }
                    if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                        orderedRowAction[index] = actionObject
                    }
                });
            } else {
                orderedRowAction.push(actionObject);
            }
            CQMasterDataStore.GridObject.updateGridField('orderedRowAction', orderedRowAction);
        } else {
            orderedRowAction.forEach((orderedAction: any, index: number) => {
                let action = { ...orderedAction }
                if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                    orderedRowAction.splice(index, 1);
                }
            });
            CQMasterDataStore.GridObject.updateGridField('orderedRowAction', orderedRowAction);
        }

    }

    private checkIfRecordExist = () => {
        let orderedRowAction = [...CQMasterDataStore.GridObject.orderedRowAction];
        const ifExist = orderedRowAction.some((orderedAction: any, index: number) => {
            let action = { ...orderedAction }
            if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                return true
            }
            return false;
        });
        return ifExist;
    }

    private saveDataToStore = (actionObject: any) => {
        const outputConfig: any = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
        actionObject && Object.keys(actionObject.actionJSON).length && Object.keys(actionObject.actionJSON).map((objKey: string) => {
            if (objKey === 'rowFormRules') {
                const headerFormRules = { ...outputConfig.rowFormRules, ...actionObject.actionJSON[objKey] };
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, headerFormRules);
            } else if (objKey === 'rowActions') {
                let rowActions = [...outputConfig.rowActions];

                const ifExist = rowActions.some((action: any) => action.name === this.state.name);
                if (ifExist) {
                    rowActions.forEach((action: any, index: number) => {
                        if (action.name === this.state.name) {
                            rowActions[index] = { ...actionObject.actionJSON[objKey] };
                        }
                    });
                } else {
                    rowActions.push({ ...actionObject.actionJSON[objKey] })
                }
                rowActions = Array.from(new Set(rowActions));
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, rowActions);
            }
        });
        const parentFields = [...outputConfig.parentFields, ...this.state.parentFields];
        if (parentFields.length > 0) {
            const parentFieldsArray = Array.from(new Set(parentFields));
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'parentFields', parentFieldsArray);
        }
    }

    private updateRuleElements = () => {
        let ruleElementsObj = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        let gridObj = { ...ruleElementsObj.gridObject };
        debugger;
        if (gridObj.hasOwnProperty('rowActions')) {
            let rowActions = { ...gridObj.rowActions };
            let tempObj = { ...this.state };
            delete tempObj.searchResult;
            delete tempObj.searchText;
            delete tempObj.componentList;
            rowActions[this.state.name] = { ...rowActions[this.state.name], ...tempObj };
            gridObj.rowActions = rowActions;
        } else {
            let rowActions: any = {};
            let tempObj = { ...this.state };
            delete tempObj.searchResult;
            delete tempObj.searchText;
            delete tempObj.componentList;
            rowActions[this.state.name] = { ...rowActions, ...tempObj };
            gridObj = { ...gridObj, 'rowActions': rowActions };
        }
        ruleElementsObj.gridObject = gridObj;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
    }
}

export const CustomRowActionComponentRootComponent = observer(
    CustomRowActionComponent
);